
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo",
      function () {
        return require("private-next-pages/demo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo"])
      });
    }
  